import { UnderSectionGroupDto } from './under-section-group-dto.model';


export class UnderSectionDto implements IUnderSectionDto {
    id!: number | undefined;
    financialYear!: string | undefined;
    underSectionGroup!: UnderSectionGroupDto;
    name!: string | undefined;
    isActive!: boolean;

    constructor(data?: IUnderSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialYear = _data["financialYear"];
            this.underSectionGroup = _data["underSectionGroup"] ? UnderSectionGroupDto.fromJS(_data["underSectionGroup"]) : <any>undefined;
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UnderSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnderSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialYear"] = this.financialYear;
        data["underSectionGroup"] = this.underSectionGroup ? this.underSectionGroup.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUnderSectionDto {
    id: number | undefined;
    financialYear: string | undefined;
    underSectionGroup: UnderSectionGroupDto;
    name: string | undefined;
    isActive: boolean;
}

